import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DigitOnlyDirective } from './directives/digit-only.directive';
import { DropdownDirective } from './directives/dropdown.directive';
import { NgLetDirective } from './directives/ng-let.directive';
import { NgPrintDirective } from './directives/ng-print.directive';
import { DecimalFormatPipe } from './pipes/decimal-format.pipe';
import { StripHtmlPipe } from './pipes/striphtml.pipe';
import { TranslateCutPipe } from './pipes/translate-cut.pipe';
import { ComponentsFactoryService } from './service/components-factory/components-factory.service';
import { CustomDateFormatPipe } from './pipes/custom-date-format.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    StripHtmlPipe,
    DecimalFormatPipe,
    TranslateCutPipe,
    NgLetDirective,
    NgPrintDirective,
    DropdownDirective,
    DigitOnlyDirective,
    CustomDateFormatPipe,
  ],
  exports: [
    StripHtmlPipe,
    DecimalFormatPipe,
    TranslateCutPipe,
    NgLetDirective,
    NgPrintDirective,
    DropdownDirective,
    DigitOnlyDirective,
    CustomDateFormatPipe,
  ],
  providers: [ComponentsFactoryService],
})
export class SharedUtilsModule {}
